const getHero = () => {
  return document.querySelector('#main .fnc-homepage-large-hero') ||
    document.querySelector('#main .coop-c-standardhero') ||
    document.querySelector('#main .coop-c-pagehero') ||
    document.querySelector('#main .coop-c-planhero') ||
    document.querySelector('#main .fnc-c-hero-feature');
};

export const initStickyCta = () => {
  const stickyCta = document.getElementById('sticky-cta');
  if (!stickyCta) {
    return;
  }


  const closeBtn = stickyCta.querySelector('.fnc-sticky-cta__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      const button = document.querySelector('.embeddedMessagingConversationButton');
      stickyCta.style.display = 'none';
      if(button) {
        button.style.bottom = 'var(--eswButtonBottom, 25px)';
      }
    });
  }

  function handleScroll() {
    const heroEl = getHero();

    const rect = heroEl && heroEl.getBoundingClientRect();
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;
    const isAtPageBottom = scrollPosition >= pageHeight - 50;

    if (rect && rect.bottom > 0 || isAtPageBottom) {
      document.body.classList.remove('fnc-sticky-cta-visible');
    } else {
      document.body.classList.add('fnc-sticky-cta-visible');
    }
  }

  let ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function onScroll() {
    requestTick();
    ticking = false;
  }

  handleScroll();

  window.addEventListener('scroll', onScroll);
};